// Meta Pixel (Facebook/Instagram Ads).
// Mismo patrón y mismo consentimiento de cookies que googleAnalytics.js:
// solo se carga si el usuario aceptó cookies (wayo_cookie_consent === 'accepted').
// Se usa para medir registros de coach desde /coaches y optimizar los Meta Ads
// hacia el evento estándar `CompleteRegistration`.
const PIXEL_ID = '786656709528205';
const CONSENT_KEY = 'wayo_cookie_consent';

let pixelLoaded = false;

export const hasPixelConsent = () => {
  if (typeof window === 'undefined') return false;

  return window.localStorage.getItem(CONSENT_KEY) === 'accepted';
};

export const loadMetaPixel = () => {
  if (typeof window === 'undefined' || pixelLoaded || !hasPixelConsent()) {
    return;
  }

  pixelLoaded = true;

  // Snippet oficial de Meta (fbevents.js), adaptado a carga diferida.
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */

  window.fbq('init', PIXEL_ID);
  window.fbq('track', 'PageView');
};

// PageView en cada cambio de ruta (SPA). Meta necesita el track manual porque
// el snippet solo dispara el primero al cargar.
export const metaPageView = () => {
  if (typeof window !== 'undefined' && hasPixelConsent()) {
    loadMetaPixel();
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }
  }
};

export const metaTrackEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && hasPixelConsent()) {
    loadMetaPixel();
    if (window.fbq) {
      window.fbq('track', eventName, params);
      console.log(`Meta Pixel event: ${eventName}`, params);
    }
  }
};

// Evento estándar de conversión: un coach ha creado su cuenta en /coaches.
// Es el que Meta Ads usa para optimizar la campaña hacia registros reales.
export const trackCoachRegistration = (source = 'coach_register') => {
  metaTrackEvent('CompleteRegistration', {
    content_name: 'Wayo Coach',
    status: source,
  });
};
